import axiosInstance from '../axiosInstance';

const getStatusByRequestIdAPI = (requestId) => {
    const url = `${import.meta.env.VITE_APP_APPLICATION_ENDPOINT}/request/${requestId}/status`;
    return axiosInstance.get(url);
};

export default {
    getStatusByRequestIdAPI,
};
